import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationBoxComponent } from 'app/components/confirmation-box/confirmation-box.component';
import { DataService } from 'app/data.service';
import { EditUserComponent } from 'app/edit-user/edit-user.component';
import { PagerService } from 'app/pager.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-view-users',
  templateUrl: './view-users.component.html',
  styleUrls: ['./view-users.component.css']
})
export class ViewUsersComponent implements OnInit {

  constructor(private dataService : DataService, private pagerService : PagerService, private dialog: MatDialog, private notification: MatSnackBar) { }

  users = [];

  lastpage: number;

  page: number = 1

  loading: boolean

  selected:string = 'createdasc';

  firstName: string = ''

  phone: string = ''

  ngOnInit(): void {
    this.getUsers()
  }

  getUsers(){
    let offset = (this.page - 1)*20
    this.dataService.getUsers(offset, this.selected)
		.subscribe((users:any) => {
      this.users = users.users.rows;
      this.lastpage = Math.ceil(users.users.count/20)
  	});
  }

  search(){
    if(this.firstName.length > 0){
      this.searchUsingName()
    }else if(this.phone.length > 0){
      this.searchByPhone()
    }else{
      this.getUsers()
    }
  }

  searchUsingName(){
    let offset = (this.page - 1)*20
    this.dataService.getUsersByName(this.firstName, offset)
		.subscribe((users:any) => {
      this.users = users.users.rows;
      this.lastpage = Math.ceil(users.users.count/20)
  	});
  }

  editUser(user){
    let dialogRef = this.dialog.open(EditUserComponent, {
      width: '800px',
      data: {
        id: user.id,
        firstName: user.firstName,
        lastName: user.lastName,
        dob: user.dob,
        email: user.Credential.email
      }
    })

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        let index = this.users.indexOf(user)
        this.users[index] = result
      }
    })
  }

  deleteUser(user, index){
    let dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      width: '400px',
      data: {
        text: 'Are you sure you want to delete this user?'
      }
    })
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.dataService.deleteUser(user.id).subscribe(data => {
          if(data.status){
            this.users.splice(index, 1)
            this.openNotification('User has been deleted!')
          }
        }, error => {
          if(error.status == 404){
            this.openNotification(error.error.message)
          }
        })
      }
    })
  }

  openNotification(msg){
    this.notification.open(msg, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

  searchByPhone(){
    this.users = []
    this.page = 1
    this.lastpage =1
    this.dataService.getUserByPhone(this.phone)
		.subscribe(data => {
      if(data.users)
        this.users.push(data.users)
  	});
  }

  firstPage(){
    if(this.page != 1){
      this.page = 1
      this.loading = true
      this.getUsers()
    }
  }

  previousPage(){
    if(this.page > 1){
      this.page = this.page - 1
      this.loading = true
      this.getUsers()
    }
  }

  nextPage(){
    if(this.page < this.lastpage){
      this.page = this.page + 1
      this.loading = true
      this.getUsers()
    }
  }

  lastPage(){
    if(this.page != this.lastpage){
      this.page = this.lastpage
      this.loading = true
      this.getUsers()
    } 
  }
  
 	

}
